import BaseApi from '@humandigital-agency/base-api';

export default class Api extends BaseApi {
    constructor() {
        super();
        this.test = false;
        this.url = '/umbraco/api/vacancyoverview/';
    }

    getOverview(data) {
        if (this.test) {
            let testData = [];

            for(let i = 0; i < app.random(100, 5000); i++) {
                let item = {
                    NodeId: app.random(1, 1000000),
                    City: app.random(1, 10) > 5 ? app.randomString(10, 50) : null,
                    Title: app.randomString(app.random(10, 40)),
                    Subtitle: app.random(1, 10) > 5 ? app.randomString(10, 50) : null,
                    ImageUrl: null,
                    GroupType: 'Niet boeiend',
                    Lat: app.random(518016654, 526966823) / 10000000,
                    Lon: app.random(46889111, 59211627) / 10000000,
                    Distance: app.random(100, 10000),
                    Duration: app.random(1, 10) > 5 ? app.randomString(10, 30) : null,
                    Intro: app.random(1, 10) > 5 ? app.randomString(100, 300) : '',
                    Url: '/',
                };
                testData.push(item);
            }

            return super.test(testData, 'getoverview');
        }

        return super.fetch(
            'getoverview', 
            this.methods.get,
            data, 
            {
                'Content-Type': 'application/json',
            }
        )
    }
}